import React from "react";

const WhyChooseUsOne = () => {
  return (
    <div className="wcu-area-1 space-bottom">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-lg-6">
            <div className="title-area text-center">
              <span className="sub-title">What we do</span>
              <h2 className="sec-title">
                Dependable Car Repair The Solutions{" "}
                <img
                  className="title-bg-shape shape-center"
                  src="assets/img/bg/title-bg-shape.png"
                  alt="800speedy"
                />
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row gy-40 gx-60 align-items-center">
          <div className="col-xl-4 order-xl-2">
            <div className="wcu-thumb-1">
              <img src="assets/img/normal/wcu-thumb-1-1.png" alt="800speedy" />
            </div>
          </div>
          <div className="col-xl-4 col-md-6 order-xl-1">
            <div className="wcu-card-wrap right-wrap">
              <div className="wcu-card">
                <div className="icon">
                  <img src="assets/img/icon/wcu-icon_2-1.svg" alt="800speedy" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">Auto Fixers</h4>
                  <p className="wcu-card-text">
                    A car repair is a service provided to fix any issues or
                    damages with y vehicle It involves diagnosing{" "}
                  </p>
                </div>
              </div>
              <div className="wcu-card">
                <div className="icon">
                  <img src="assets/img/icon/wcu-icon_2-2.svg" alt="800speedy" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">Mechanic Masters</h4>
                  <p className="wcu-card-text">
                    A car repair is a service provided to fix any issues or
                    damages with y vehicle It involves diagnosing{" "}
                  </p>
                </div>
              </div>
              <div className="wcu-card">
                <div className="icon">
                  <img src="assets/img/icon/wcu-icon_2-3.svg" alt="800speedy" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">Car Care Clinic</h4>
                  <p className="wcu-card-text">
                    A car repair is a service provided to fix any issues or
                    damages with y vehicle It involves diagnosing{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-md-6 order-xl-3">
            <div className="wcu-card">
              <div className="icon">
                <img src="assets/img/icon/wcu-icon_2-4.svg" alt="800speedy" />
              </div>
              <div className="wcu-card-details">
                <h4 className="wcu-card-title">Precision Auto Works</h4>
                <p className="wcu-card-text">
                  A car repair is a service provided to fix any issues or
                  damages with y vehicle It involves diagnosing{" "}
                </p>
              </div>
            </div>
            <div className="wcu-card">
              <div className="icon">
                <img src="assets/img/icon/wcu-icon_2-5.svg" alt="800speedy" />
              </div>
              <div className="wcu-card-details">
                <h4 className="wcu-card-title">Drive-In Garage</h4>
                <p className="wcu-card-text">
                  A car repair is a service provided to fix any issues or
                  damages with y vehicle It involves diagnosing{" "}
                </p>
              </div>
            </div>
            <div className="wcu-card">
              <div className="icon">
                <img src="assets/img/icon/wcu-icon_2-6.svg" alt="800speedy" />
              </div>
              <div className="wcu-card-details">
                <h4 className="wcu-card-title">Speedy Auto Repair</h4>
                <p className="wcu-card-text">
                  A car repair is a service provided to fix any issues or
                  damages with y vehicle It involves diagnosing{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUsOne;
